import { Link } from 'react-router-dom';

const programCards = [
  {
    icon: 'ri-line-chart-line',
    title: 'Тренинг по продажам',
    description: 'Повышение конверсии, работа с возражениями, сценарии встреч и построение долгосрочных отношений с клиентами.',
    to: '/prodazhi-i-peregovory/trening-po-prodazham',
  },
  {
    icon: 'ri-discuss-line',
    title: 'Тренинг по переговорам',
    description: 'Эффективные стратегии, метасообщения, психологические приёмы и достижение win-win решений.',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
  },
  {
    icon: 'ri-phone-find-line',
    title: 'Холодные звонки',
    description: 'Обучение холодным звонкам: от страха до уверенных встреч с ЛПР.',
    to: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam',
  },
  {
    icon: 'ri-phone-line',
    title: 'Телефонные продажи',
    description: 'Эффективные техники телефонных продаж в современном мире мессенджеров.',
    to: '/prodazhi-i-peregovory/trening-po-telefonnym-prodazham',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Продажи B2B',
    description: 'Сложные продажи, работа с ЛПР, длинный цикл сделки и увеличение конверсии.',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-b2b',
  },
  {
    icon: 'ri-chat-check-line',
    title: 'Работа с возражениями',
    description: 'Техники обработки возражений и превращения их в возможности для продажи.',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami',
  },
];

export default function PopularProgramsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-star-line"></i>
            Тренинги
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Популярные программы обучения
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Практические корпоративные тренинги для развития ключевых компетенций вашей команды. Каждая программа адаптируется под специфику вашего бизнеса.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {programCards.map((card, index) => (
            <Link
              key={index}
              to={card.to}
              className="group bg-gray-50 rounded-xl p-6 hover:shadow-lg hover:bg-teal-50/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${card.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">
                {card.description}
              </p>
              <span className="inline-flex items-center text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all gap-1 whitespace-nowrap">
                Подробнее <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/prodazhi-i-peregovory/trening-po-prodazham"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Посмотреть все программы <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}